import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        identifier: '',
        password: ''
    };
    public csrfToken: string = '';
    public processing: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        const response: any = await wiz.call('status');
        if (response.code === 200) {
            this.csrfToken = response.data.csrfToken || '';
            if (response.data.authenticated) return location.href = "/dashboard";
        }
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.identifier) {
            await this.alert("아이디 또는 이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        if (this.processing) return;
        this.processing = true;
        user.csrfToken = this.csrfToken;
        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/dashboard";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
        this.processing = false;
    }
}

export default PageAccessComponent;